import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_INDEX } from '@core/config/route-paths.config';
import { SessionService } from '@core/services/session.service';

export const guestGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.session) {
    return router.createUrlTree([`/${ROUTE_INDEX}`]);
  }

  return true;
};
